import { IconButton, Tooltip, Typography } from "@mui/material";
import { SimpleTable } from "../../../components/mui/table";
import { RENDERER_TYPES } from "../../../enums";
import {
  DATE_FORMATS,
  formatDate,
  isSelectedTimeSlotPast,
} from "../../../services/date-and-time.utils";
import { convertToFullName } from "../../../services/utils";
import { AppChip } from "../../../components/chips";
import { useState } from "react";
import { ProjectStatus } from "../components/project-status";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import FlexBox from "../../../components/layouts/flexbox";

function InvitationListTable({
  list,
  columns,
  handlePageFilters,
  appliedFilters,
  onInvitationAceeptClick,
  onInvitationRejectClick,
  onInvitationDeleteClick,
  onRescheduleInvitationClick,
}) {
  const { selectedPage, selectedPageSize } = appliedFilters;
  const handleTDRenderer = (row, column) => {
    switch (column.rendererType) {
      case RENDERER_TYPES.FULL_NAME:
        if (column.field === "ambassador") {
          return (
            <>
              <Typography fontSize={13} fontWeight="400" color="#6C7293">
                {convertToFullName(
                  row.ambassador.firstName,
                  row.ambassador.lastName
                )}
              </Typography>
              <Typography fontSize={12} fontWeight="400" color="#A7ABC3">{`${
                row.ambassador.title || ""
              }`}</Typography>
              <ViewSecondaryMembers
                secondaryMembers={row?.ambassador?.secondaryMembers}
              />
              {row.isAmbassadorAttend &&
                !isSelectedTimeSlotPast(row.selectedTimeSlot) && (
                <FlexBox alignItems="center" gap={0.5} mt={0.25}>
                  <CheckCircleIcon sx={{ fontSize: 16, color: "#41C197" }} />
                  <Typography fontSize={11} fontWeight={600} color="#41C197">
                    Availability confirmed
                  </Typography>
                </FlexBox>
              )}
            </>
          );
        }
        if (column.field === "client") {
          return (
            <>
              <Typography fontSize={13} fontWeight="400" color="#6C7293">
                {convertToFullName(row.client.firstName, row.client.lastName)}
              </Typography>
              <Typography fontSize={12} fontWeight="400" color="#A7ABC3">{`${
                row.client.email || ""
              }`}</Typography>
              <Typography
                fontSize={12}
                mb={1}
                fontWeight="400"
                color="#A7ABC3"
              >{`${row.client.title || ""}`}</Typography>
              <ViewSecondaryMembers
                secondaryMembers={row?.client?.secondaryMembers}
              />
            </>
          );
        }
        return;
      case RENDERER_TYPES.DATE_RANGE:
        return `${formatDate(
          row.selectedTimeSlot.from,
          DATE_FORMATS.fullDateWithTime
        )} - ${formatDate(
          row.selectedTimeSlot.to,
          DATE_FORMATS.hourMinWithAMPM
        )}`;
      case RENDERER_TYPES.MEETING_STATUS:
        return <ProjectStatus data={row} labelField="displayLabel" />;
      case RENDERER_TYPES.ACTION:
        if (row.status === "done" || row.isRejected || row.status === "archive")
          return false;

        return (
          <FlexBox alignItems="center" justifyContent="center" gap={0.5}>
            <Tooltip title="Approve">
              <IconButton
                size="small"
                aria-label="Approve"
                onClick={() => onInvitationAceeptClick(row.id)}
              >
                <CheckCircleOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reject">
              <IconButton
                size="small"
                aria-label="Reject"
                color="error"
                onClick={() => onInvitationRejectClick(row.id)}
              >
                <CancelOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reschedule">
              <IconButton
                size="small"
                aria-label="Reschedule"
                onClick={() => onRescheduleInvitationClick(row)}
              >
                <EditCalendarOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </FlexBox>
        );
      default:
        break;
    }
  };

  return (
    <SimpleTable
      tdRenderer={handleTDRenderer}
      rows={list?.data}
      columns={columns}
      fetching={list?.loading}
      total={list?.total}
      onPageSettingsChange={handlePageFilters}
      selectedPage={selectedPage}
      selectedPageSize={selectedPageSize}
    ></SimpleTable>
  );
}

function ViewSecondaryMembers({ secondaryMembers = [] }) {
  const [show, setShow] = useState(false);

  if (!show)
    return (
      <Typography
        style={{ cursor: "pointer", textDecoration: "underline" }}
        variant="caption"
        onClick={() => setShow(!show)}
      >
        View Secondary Emails
      </Typography>
    );

  return (
    <>
      {secondaryMembers?.map((item) => (
        <AppChip
          key={item}
          bgColor="#F2F3F8"
          style={{ marginRight: 3, marginBottom: 3 }}
          label={item}
          fontColor={"#6C7293"}
        />
      ))}
    </>
  );
}

export { InvitationListTable };
